import { DefinitionDto } from "@app/modules/shared/model/definition.dto";

export class SectorDto extends DefinitionDto {}
